import { MainMenuItem } from "types/MainMenuItem";

export const menuItems: MainMenuItem[] = [
  {
    key: "liquid-staking",
    label: "Polygon",
    icon_key: "polygon",
    disabled: false,
    subMenus: [
      {
        key: "maticx",
        label: "Stake",
        disabled: false,
        to: "/liquid-staking/maticx",
      },
      {
        key: "defi",
        label: "DeFi",
        disabled: false,
        badge: "new",
        to: "/liquid-staking/defi",
      },
    ],
  },
];

export const extraItems = [
  {
    title: "Theme",
    key: "theme",
  },
  {
    key: "faq",
    title: "FAQs",
    link: "https://docs-new.staderlabs.com/category/polygon",
  },
  {
    key: "support",
    title: "Support",
    link: "https://t.me/StaderLabs_Polygon_Official",
  },
];

export const liquidStakingOptions = [
  {
    key: "hedera",
    title: "Hedera",
    link: "https://hedera.staderlabs.com/lt/hedera",
  },
  {
    key: "fantom",
    title: "Fantom",
    link: "https://fantom.staderlabs.com/liquid-staking/pools/",
  },
  {
    key: "bnb",
    title: "BNB",
    link: "https://bnbchain.staderlabs.com/liquid-staking/bnbx",
  },
  {
    key: "near",
    title: "Near",
    link: "https://near.staderlabs.com/",
  },
  {
    key: "terra",
    title: "Terra",
    link: "https://terra.staderlabs.com/liquid-staking",
  },
];
